export default __webpack_public_path__ + "static/media/smartmockups_kl7ie8ha.4ca699c8.jpg";